const getSentryEnvName = (env) =>
	env === "DEV" ? "development" : (env || "LOCAL").toLowerCase();

module.exports = {
	getSentryEnvName,
};
